module.exports = __webpack_public_path__ + "img/14.70a9b2fd.png";